import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { ChartFormSubsection, OrderHistoryItem } from "modules/charts-shared";
import { SignatureDto } from "modules/onboarding/api";

type ChartEkgFormSubsectionResponse = ChartFormSubsection & {
  order?: Partial<OrderHistoryItem>;
  orderId: string;
  signature?: SignatureDto;
};

function useEkg(encounterId: string) {
  return useAxiosQuery(["ekg", { encounterId }], () =>
    axiosChartInstance.get<ChartEkgFormSubsectionResponse[]>(
      `v1/chart/${encounterId}/ekg`
    )
  );
}

export { useEkg };
export type { ChartEkgFormSubsectionResponse };
